import React from 'react';
import FifthSection from './Home/FifthSection';
import FourthSection from './Home/FourthSection';
import Hero from './Home/Hero';
import Secondcomp from './Home/Secondcomp';
import SixthSection from './Home/SixthSection';
import ThirdSection from './Home/ThirdSection';

export default function Home() {
 return (
  <>
   <Hero />
   <Secondcomp />
   <ThirdSection />
   <FourthSection />
   <FifthSection />
   <SixthSection />
  </>
 );
}
